module.exports = __webpack_public_path__ + "img/icon-speed-gray.0000c3ee.svg";